module.exports = __webpack_public_path__ + "static/immutable-d2be58123d4283eb36498506f83a9c62.svg";